import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative w-full max-w-md mx-auto" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3.5 rounded-xl bg-background-50 border border-background-200/70 text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-grid-line text-accent-600 text-lg"></i>
          </div>
          <span className="font-medium text-sm">Browse Categories</span>
        </div>
        <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-50 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-5 py-3 hover:bg-accent-50 transition-colors cursor-pointer"
            >
              <div className="w-8 h-8 rounded-lg bg-accent-50 flex items-center justify-center flex-shrink-0">
                <i className={`${cat.icon} text-accent-500 text-base`}></i>
              </div>
              <span className="text-sm text-foreground-800 font-medium">{cat.name}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}